<template>
    <div class="box-container">
        <div class="box-container-header">
            <h2 class="box-title">
                {{ $t('DASHBOARD.TITLE.FAIL_RULE') }}<!--실패한 규칙-->
                <button type="button" class="buttons-icon" data-type="ghost" data-size="xs" data-icon="info" data-trigger="tooltip" :title="$t('DASHBOARD.FAIL_RULE.TOOLTIP')">info</button>
            </h2>

            <div class="actions">

                <router-link v-bind:to="'/compliance?cmplRslt=F'" class="buttons" data-type="ghost" data-size="s" data-icon-right="open"><span class="open">{{ $t('DASHBOARD.FAIL_RULE.VIEW_EVALUATION_LIST')}}<!--검사 목록 보기--></span></router-link>
                <dashboard-widget v-bind:type="'rule'"></dashboard-widget>
            </div>
        </div>
        <div class="tbl-collapse" data-type-summary data-linkable-row>
            <div class="thead pl-3">
                <div class="row">
                    <span class="cell" data-size="auto">
                        <button type="button" class="buttons-tbl-header"
                                v-bind:data-type="sortColumn !== 'titl' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
                                v-on:click="setSortColumn('titl')">{{ $t('DASHBOARD.FAIL_RULE.HEADER.POLICY_NAME')}}<!--정책 이름--></button>
                    </span>
                    <span class="cell" data-size="status02" data-align="center">
                        <button type="button" class="buttons-tbl-header">{{ $t('DASHBOARD.FAIL_RULE.HEADER.EVALUATION_STATUS')}}<!--검사 상태--></button>
                    </span>
                    <span class="cell" data-size="date" data-align="center">
                        <button type="button" class="buttons-tbl-header"
                                v-bind:data-type="sortColumn !== 'execDt' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
                                v-on:click="setSortColumn('execDt')">{{ $t('DASHBOARD.FAIL_RULE.HEADER.EVALUATED_AT')}}<!--검사 일시--></button>
                    </span>
                    <span class="cell" data-align="center"></span>
                </div>
            </div>
            <div-loading v-if="pending"></div-loading>
            <div v-else class="tbody pl-3" style="height: 276px;">
                <div class="row none" v-if="getComplianceList == null || getComplianceList.length == 0">
                    {{ $t('COMMON.NO_RULE_FAIL') }}
                </div>
                <div class="row" v-for="(cmpl, idx) in getComplianceList" :key="idx">
                    <div class="cells">
                        <span class="cell" data-size="auto">
                            <div class="policy-item">
                                <span class="icon-tag" :data-type="cmpl.userDefiYn == constants.PARAM.SELECT.Y ? 'policy-custom' : 'policy-system'">{{ $t( cmpl.userDefiYn == constants.PARAM.SELECT.Y ? 'TYPE.CUSTOM' : 'TYPE.BEST_PRACTICE')}}<!--사용자 설정--></span>
                                <span class="name" :title="cmpl.userDefiYn == constants.PARAM.SELECT.N ? cmpl[$i18n.locale+'Title'] : cmpl.titl">{{cmpl.userDefiYn == constants.PARAM.SELECT.N ? cmpl[$i18n.locale+'Title'] : cmpl.titl}}</span>
                                <span class="count">
                                    <span class="error">{{ $t('DASHBOARD.FAIL_RULE.POLICY_NAME_CONTENTS_FAIL', {'fCnt':cmpl.failCnt})}}<!--실패 0개--></span>
                                    | {{ $t('DASHBOARD.FAIL_RULE.POLICY_NAME_CONTENTS_TOTAL', {'tCnt':cmpl.ruleTotCnt})}} <!--0개 규칙-->
                                </span>
                            </div>
                        </span>
                        <span class="cell" data-size="status02" data-align="center">
                            <span class="icon-tag" data-type="failer">{{ $t('DASHBOARD.FAIL_RULE.FAIL') }}
                                <template v-if="cmpl.execYn && cmpl.execYn == 'Y'">({{ $t('DASHBOARD.FAIL_RULE.SOLVED')}}<!--해결-->)</template>
                                <template v-else>({{ $t('DASHBOARD.FAIL_RULE.UNSOLVED') }}<!--미해결-->)</template>
                            </span>
                        </span>
                        <span class="cell" data-size="date">
                            <time class="date-center" datetime="">{{ convertUtcTimezoneToLocal(cmpl.execDt) }}</time>
                        </span>
                        <span class="cell" data-align="center">
                            <button @click="moveToDetail(cmpl)">
                                <span class="icon-detail-disclosure"></span>
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
import DashboardWidget from "./dashboardWidget.vue";
import {mapGetters} from "vuex";

export default {
    name: 'DashboardFailRule',
    components: {
        DashboardWidget
    },
    props: ['filter'],
    data: function () {
        return {
            rawDataList: [],
            cmplList: [],
            pending: false,

            sortColumn: '',                                // Sort column
            sortOrder: '',                                 // Sort order
        }
    },
    created: function () {
        this.slctCmplList();
    },
    watch: {
        curCmpnId: function () {
            this.slctCmplList();
        }
    },
    computed: {
        ...mapGetters({
            curCmpnId: 'user/curCmpnId'
        }),
        getLocale: function () {
            return this.$i18n.locale
        },
        getComplianceList: function () {
            let self = this;
            let list = this.cmplList;

            if (this.sortColumn !== '' && this.sortOrder !== '') {
                list = _.orderBy(self.cmplList, [self.sortColumn], [self.sortOrder])
            }

            return list.length > 0 ? list : [];
        },
    },
    methods: {
        slctCmplList: function () {
            var url = "/api/governance/cmpl/list";
            var header = {
                'cmpnId': this.curCmpnId,
                'searchStatHeader': ['F'],
                'isLimitPage': false
            }

            this.pending = true

            this.http.post(url, JSON.stringify(header))
                .then(response => {
                    this.pending = false
                    if (response.status === 200) {
                        this.rawDataList = response.data.result;

                        this.applyFilterRawData();
                    }
                })

        },
        applyFilterRawData() {
            let self = this;
            this.cmplList = this.rawDataList;

            // account filter 적용
            if (this.filter != null && this.filter.acnt != null && typeof (this.filter.acnt) !== 'undefined' && this.filter.acnt.length > 0) {

                this.cmplList = _.filter(this.rawDataList, function (o) {
                    let isInclude = false;
                    for (let acnt of self.filter.acnt) {
                        isInclude = _.includes(o.accArr, acnt)
                        if (isInclude) break;
                    }
                    return isInclude;
                });
            }
        },
        convertUtcTimezoneToLocal: function (date) {
            return date == null ? '-' : this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale)
        },
        moveToDetail(cmpl) {
            const url = "/compliance/detail";
            const {cmplId, rsltId} = cmpl;
            if (rsltId) {
                this.$router.push({path: url, query: {cmpl: cmplId, rslt: rsltId}});
            } else {
                this.$router.push({path: url, query: {cmpl: cmplId}});
            }
        },
        setSortColumn: function (sortColumn) {
            if (this.sortColumn !== sortColumn) {
                this.sortColumn = sortColumn
                this.sortOrder = 'asc'
            } else if (this.sortColumn === sortColumn && this.sortOrder === 'asc') {
                this.sortOrder = 'desc'
            } else if (this.sortColumn === sortColumn && this.sortOrder === 'desc') {
                this.sortColumn = ''
                this.sortOrder = ''
            }
        },
    }

}
</script>

<style scoped>
.date-center {
    padding: 12%;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/dashboardFailRule.vue